import {env} from '../config/env.js';
import {authedFetch} from './auth-fetch.js';
import {lookupEntityEndpoint} from './entity-endpoint-registry.js';

export interface MorphedReadOptions {
    filters?: Record<string, unknown>[];
    options?: {
        limit?: number;
        offset?: number;
        fields?: string[];
        orderBy?: string;
        orderDirection?: 'asc' | 'desc';
    };
    relations?: boolean;
    relationsDepth?: number;
    metadata?: boolean;
    allowPublic?: boolean;
}

export function resolveEndpoint(entityName: string): string {
	// Preferir el endpoint canonico registrado desde las definiciones (evita slugify erroneo
	// para nombres con acentos/palabras como "del").
	const canonical = lookupEntityEndpoint(entityName);
	if (canonical) return canonical;
	return entityName
		.replace(/([A-Z])/g, '-$1')
		.toLowerCase()
		.replace(/^-/, '')
		.replace(/\s+/g, '-')
		.replace(/-+/g, '-');
}

export async function morphedRead<T = Record<string, unknown>>(
    entityName: string,
    opts: MorphedReadOptions = {},
): Promise<T[]> {
    const endpoint = resolveEndpoint(entityName);
    const body: Record<string, unknown> = {
        filters: opts.filters,
        options: opts.options,
        relations: opts.relations,
        relationsDepth: opts.relationsDepth,
        metadata: opts.metadata,
    };
    if (opts.allowPublic) body.allowPublic = true;
    const res = await authedFetch(`${env.MORPHED_API_URL}/${endpoint}/read`, {
        method: 'POST',
        body: JSON.stringify(body),
        audience: 'morphed',
    });
    if (!res.ok) throw new Error(`morphed read "${entityName}" fallo: ${res.status}`);
    const json = await res.json();
    return (json.data ?? []) as T[];
}

export async function morphedCount(entityName: string, filters?: Record<string, unknown>[]): Promise<number> {
    const endpoint = resolveEndpoint(entityName);
    const res = await authedFetch(`${env.MORPHED_API_URL}/${endpoint}/count`, {
        method: 'POST',
        body: JSON.stringify({filters: filters ?? []}),
        audience: 'morphed',
    });
    if (!res.ok) throw new Error(`morphed count "${entityName}" fallo: ${res.status}`);
    const json = await res.json();
    return Number(json.count ?? json.data?.[0]?.count ?? 0);
}
